import { GenericMachine } from '_core/domain/Utils/Generic/Machines/GenericMachine';
import { isValidLogin } from '_core/helpers/validations';
import { IDocs } from '_core/types';
import { Bundle } from '_core/util';
import { memberStatusApi as API } from '../Apis';

export const MemberStatusDocs: IDocs = {
  title: 'MemberStatus',
  description: '',
  version: '0.0.1',
  apis: [
    {
      name: API.definitions.API_DOMAIN,
      path: API.definitions.ENDPOINT_API_PATH,
      linkPostman: API.definitions.URL_POSTMAN,
      order: 1,
    },
  ],
  codeToExecute: 'Services.AccountServices.getMemberStatus',
};

const prepareCall = (stateRequestParameters: any) => {
  const loginData = isValidLogin(stateRequestParameters.login);
  let body = {};
  if (loginData.isValid) {
    switch (loginData.type) {
      case 'EMAIL':
        body = {
          email: stateRequestParameters.login.toLowerCase(),
        };
        break;
      case 'CPF':
        body = {
          document: {
            type: 'CPF',
            value: stateRequestParameters.login,
          },
        };
        break;
      case 'MEMBER':
        body = {
          memberNumber: stateRequestParameters.login,
        };
        break;
    }
  }

  const config = Bundle.getValue('config');
  return API.call.post({
    ...body,
    recaptcha:
      config.service.environment === 'MOCK'
        ? undefined
        : { responseToken: stateRequestParameters?.tokenRecaptcha },
  });
};

const handleSucessFinalResponseFunction = (data: any) => {
  return {
    resetPasswordByContact: data?.status === 'ACTIVE',
    ...data,
  };
};

export const MemberStatusMachine = GenericMachine(
  prepareCall,
  {
    docs: MemberStatusDocs,
    definitions: API.definitions,
  },
  {
    handleSucessFinalResponseFunction,
  },
);
